var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-buttons---konfigurator",
    transform: "translate(-150.000000, -606.000000)",
    stroke: "#DF3427",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "knapp-copy-2",
    transform: "translate(127.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    points: "0 14 0 20 6 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    transform: "translate(3.000000, 3.000000) rotate(-270.000000) translate(-3.000000, -3.000000) ",
    points: "0 0 0 6 6 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    transform: "translate(17.000000, 3.000000) rotate(-180.000000) translate(-17.000000, -3.000000) ",
    points: "14 0 14 6 20 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    transform: "translate(17.000000, 17.000000) rotate(-90.000000) translate(-17.000000, -17.000000) ",
    points: "14 14 14 20 20 20"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreen);
export default __webpack_public_path__ + "static/media/icon-fullscreen.388d3403b51031c64c4be90f4aebbe14.svg";
export { ForwardRef as ReactComponent };